<div *ngIf="loaded">
  
  <div class="product__gallery">
  
    <div class="product__gallery-view"  [ngSwitch]="selected" >
  
      <app-carousel-fluid [listCarousel]="photos" class="product__carousel--desktop"  *ngSwitchCase="'photos-carousel'" (openModal)="openModal($event)"></app-carousel-fluid>
  
      <app-carousel [listCarousel]="photos" class="product__carousel--mobile" *ngSwitchCase="'photos-carousel'" (openModal)="openModal($event)">
      </app-carousel>
  
      <app-carousel [listCarousel]="videos" class="product__carousel--desktop" [typeHtml]="'video'" *ngSwitchCase="'videos'">
      </app-carousel>
  
      <app-carousel [listCarousel]="videos" class="product__carousel--mobile" [typeHtml]="'video'" *ngSwitchCase="'videos'">
      </app-carousel>
  
      <app-map [latitude]="product.map?.lat" [longitude]="product.map?.lng" [radius]="product.map?.radius" *ngSwitchCase="'map'">
      </app-map>
  
      <app-map [latitude]="product.map?.lat" [longitude]="product.map?.lng" [idMap]="'map-landpage'" [streetView]="true" *ngSwitchCase="'street-view'">
      </app-map>

      <app-carousel-fluid [listCarousel]="plans" class="product__carousel--desktop" *ngSwitchCase="'floor_plans'" (openModal)="openModal($event)">
      </app-carousel-fluid>
      
      <app-carousel [listCarousel]="plans" class="product__carousel--mobile" *ngSwitchCase="'floor_plans'" (openModal)="openModal($event)">
      </app-carousel>
      
      <app-carousel [listCarousel]="tour360" class="product__carousel--desktop" [typeHtml]="'tour'" *ngSwitchCase="'tour360'" >
      </app-carousel>

      <app-carousel [listCarousel]="tour360" class="product__carousel--mobile" [typeHtml]="'tour'" *ngSwitchCase="'tour360'" >
      </app-carousel>
    </div>
  
    <div class="product__gallery-controllers">
      <div class="gallery-controller__left-container">
        <app-gallery-controller [selected]="selectedButton" [controllers]="controllers" (changeSelect)="setSelected($event)"></app-gallery-controller>
      </div>
  
      <div class="gallery-controller__right-container">
        
        <button [class.disable]="!enableShareButton" class="btn-compartilhar" (click)="copyToCB()">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.432 7.01678V9.15278C9.432 9.68878 9.244 10.1448 8.868 10.5208C8.492 10.8968 8.036 11.0848 7.5 11.0848H1.932C1.396 11.0848 0.94 10.8968 0.564 10.5208C0.188 10.1448 0 9.68878 0 9.15278V3.58478C0 3.05678 0.188 2.60478 0.564 2.22878C0.94 1.85278 1.396 1.66078 1.932 1.65278H6.648C6.704 1.65278 6.752 1.67278 6.792 1.71278C6.832 1.75278 6.852 1.80478 6.852 1.86878V2.30078C6.852 2.36478 6.832 2.41678 6.792 2.45678C6.752 2.49678 6.704 2.51678 6.648 2.51678H1.932C1.636 2.51678 1.384 2.62078 1.176 2.82878C0.968 3.03678 0.86 3.28878 0.852 3.58478V9.15278C0.852 9.44878 0.96 9.70078 1.176 9.90878C1.392 10.1168 1.644 10.2248 1.932 10.2328H7.5C7.796 10.2328 8.048 10.1248 8.256 9.90878C8.464 9.69278 8.568 9.44078 8.568 9.15278V7.01678C8.568 6.95278 8.588 6.90078 8.628 6.86078C8.668 6.82078 8.72 6.80078 8.784 6.80078H9.216C9.28 6.80078 9.332 6.82078 9.372 6.86078C9.412 6.90078 9.432 6.95278 9.432 7.01678ZM12 1.23278V4.65278C12 4.77278 11.956 4.87278 11.868 4.95278C11.78 5.03278 11.68 5.07678 11.568 5.08478C11.456 5.09278 11.356 5.04878 11.268 4.95278L10.092 3.77678L5.724 8.14478C5.684 8.19278 5.632 8.21678 5.568 8.21678C5.504 8.21678 5.456 8.19278 5.424 8.14478L4.656 7.37678C4.608 7.33678 4.584 7.28878 4.584 7.23278C4.584 7.17678 4.608 7.12478 4.656 7.07678L9.024 2.70878L7.848 1.53278C7.76 1.44478 7.716 1.34478 7.716 1.23278C7.716 1.12078 7.76 1.02078 7.848 0.932781C7.936 0.844781 8.036 0.800781 8.148 0.800781H11.568C11.688 0.800781 11.788 0.844781 11.868 0.932781C11.948 1.02078 11.992 1.12078 12 1.23278Z" fill="#D6283D"/>
          </svg>
          <span>Compartilhar</span>
        </button>

      </div>
    </div>
  
  </div>
  
  <app-modal [(isVisible)]="modalOpened" [nzWrapClassName]="'modal-fullscreen dark-theme'" (isVisibleChange)="handleCloseModal()"> 
  
    <app-gallery-controller [selected]="selectedButton" [controllers]="controllers"  (changeSelect)="setSelected($event)"></app-gallery-controller>
  
  
    <div class="product__gallery--modal" [ngSwitch]="selected">
  
      <app-carousel [theme]="'modal'" [listCarousel]="photos" [thumbnail]="true" [index]="index"
        *ngSwitchCase="'photos-carousel'">
      </app-carousel>
  
      <app-carousel [theme]="'modal'" [listCarousel]="videos" [typeHtml]="'video'" *ngSwitchCase="'videos'"
        [thumbnail]="true">
      </app-carousel>
  
      <div class="map-container" *ngSwitchCase="'map'">
        <app-map [latitude]="product.map?.lat" [longitude]="product.map?.lng" [radius]="product.map?.radius">
        </app-map>
      </div>
  
      <div class="map-container" *ngSwitchCase="'street-view'">
        <app-map [latitude]="product.map?.lat" [longitude]="product.map?.lng" [idMap]="'map-modal'"
          [streetView]="true">
        </app-map>
      </div>
  
      <app-carousel #plansView [theme]="'modal'" [listCarousel]="plans" [index]="index" [thumbnail]="true" *ngSwitchCase="'floor_plans'">
      </app-carousel>
  
      <app-carousel [theme]="'modal'" [listCarousel]="tour360" [typeHtml]="'tour'" *ngSwitchCase="'tour360'"
                            [thumbnail]="true">
      </app-carousel>
  
    </div>
  
  </app-modal>
</div>
